import { render, staticRenderFns } from "./measurements.table.vue?vue&type=template&id=abd06854&"
import script from "./measurements.table.vue?vue&type=script&lang=js&"
export * from "./measurements.table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports